import { Directive, Input, Inject, Optional } from '@angular/core';
import {
  RvDraggableService,
  RvDraggableItem,
  RvDroppableItem,
} from '../services/rv-draggable.service';

@Directive({
  selector: '[rvDroppableItem]',
  standalone: false,
  host: {
    class: 'rv-droppable-item',
    '[class.droppable-not-allowed]': 'dropNotAllowed',
    tabindex: '-1',
    '[attr.data-item-id]': 'itemId',
  },
})
export class RvDroppableItemDirective {
  @Input() rvDroppableItem: RvDroppableItem;
  @Input() dropNotAllowed: boolean = false;
  
  get itemId(): string {
    if (this.rvDroppableItem && this.draggableService) {
      return this.draggableService.getDroppableItemId(this.rvDroppableItem);
    }
  }

  constructor(
    @Inject(RvDraggableService)
    @Optional()
    public draggableService?: RvDraggableService<
      RvDraggableItem,
      RvDroppableItem
    >
  ) {}
}
